import FullScreenInit from "./FullScreenInit";

export default FullScreenInit;
